import * as general from "../../libs/general";
import { resultMeta } from "./scanResults";

export const StatusChip = ({ name, color }) =>
  name ? (
    <span className="warehouse-status-chip" style={{ background: color || "#eee" }}>
      {name}
    </span>
  ) : (
    <span className="text-muted">-</span>
  );

/** Danh sách kết quả quét gần nhất — dòng mới nhất ở trên. */
const ScanResultTable = ({ rows, showCustomer = true }) => (
  <div className="table-responsive warehouse-result-table">
    <table className="table table-sm table-hover align-middle mb-0">
      <thead className="table-light">
        <tr>
          <th style={{ width: 40 }}>#</th>
          <th>Thời gian</th>
          <th>Mã vận đơn</th>
          <th>Kết quả</th>
          <th>Đơn hàng</th>
          {showCustomer && <th>Khách hàng</th>}
          <th>Trạng thái</th>
          <th>Ghi chú</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 && (
          <tr>
            <td colSpan={showCustomer ? 8 : 7} className="text-center text-muted py-4">
              Chưa có mã nào được quét
            </td>
          </tr>
        )}
        {rows.map((row, index) => {
          const meta = resultMeta(row.result);
          return (
            <tr key={row.id || `${row.code}-${row.createdAt}-${index}`} className={index === 0 ? "warehouse-row-latest" : ""}>
              <td>{rows.length - index}</td>
              <td className="text-nowrap">{general.formatDateTime3(row.createdAt)}</td>
              <td className="fw-semibold text-nowrap">{row.code}</td>
              <td>
                <span className={`badge bg-${meta.variant}`}>{meta.label}</span>
              </td>
              <td className="text-nowrap">
                {row.orderCode || "-"}
                {row.orderName && <div className="small text-muted text-truncate" style={{ maxWidth: 200 }}>{row.orderName}</div>}
              </td>
              {showCustomer && <td className="text-nowrap">{row.orderCustomerCode || "-"}</td>}
              <td className="text-nowrap">
                <StatusChip name={row.statusBeforeName} color={row.statusBeforeColor} />
                {row.statusAfterId && row.statusAfterId !== row.statusBeforeId && (
                  <>
                    {" → "}
                    <StatusChip name={row.statusAfterName} color={row.statusAfterColor} />
                  </>
                )}
              </td>
              <td className="small">{row.message}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default ScanResultTable;
